export { repositoryClient } from "./client";

export function toRepositoryBody<T extends object>(payload: T): T {
  return payload;
}
